<template>
  <div class="col-md-6 col-lg-4 bloco_icon">
    <router-link :to="link_montado" class="btn btn-light d-block d-sm-block bloco_link placeholder-glow"
      :title="titulo">
      <div class="row p-0">
        <div class="img-fluid img-thumbnail rounded d-block zoomimg col-5 me-1" :class="class_placeholder"
          :style="['background-image: url(' + img_montada + ')']">
          <div class="spinner-border text-primary mt-5" v-if="img_load" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="row  col-7 p-0">
          <div class="titulo" :class="class_placeholder">
            {{ short_titulo }}
            <span class="d-flex col-10 offset-1"></span>
          </div>
          <div class="row text-start" :class="class_placeholder">
            <small class="col-12 fs-bold text-start me-0"><strong>{{ sub_titulo_curto }}</strong> </small>
            <small class="col-12 short_descr">{{ short_descr }} </small>
            <small class="col-12 short_descr_cat  mt-4 align-bottom text-start">Categoria: {{ categoria }} </small>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { limita_caracteres } from '@/assets/js/functions';
export default {
  name: "BlocoNoticias",
  props: {
    img_noticia: {
      default: null
    },
    titulo: {
      default: ''
    },
    sub_titulo: {
      default: ''
    },
    categoria: {
      default: ''
    },
    descricao: {
      default: ''
    },
    link: {
      default: ''
    },
    ativa_placeholder: {
      default: false
    },
  },
  data() {
    return {
      img_load: true,
    }
  },
  components: {},
  computed: {
    sub_titulo_curto: function () {
      if (this.sub_titulo.length > 40) {
        return limita_caracteres(this.sub_titulo, 40) + '...'
      } else {
        return this.sub_titulo
      }
    },
    short_descr: function () {
      if (this.descricao.length > 36) {
        return limita_caracteres(this.descricao, 36) + '...'
      } else {
        return this.descricao
      }
    },
    short_titulo: function () {
      try {
        var qtd_tit = this.titulo.length
        if (qtd_tit > 26) {
          return limita_caracteres(this.titulo, 26) + '...'
        } else {
          return this.titulo
        }
      } catch (error) {
        return this.titulo
      }
    },
    img_montada: function () {
      if (this.img_noticia) {
        return this.$site + '/img/news/' + this.img_noticia
      } else {
        return this.$site + '/img/logo.png'
      }
      this.img_load = false
    },
    link_montado: function () {
      return '/noticias/lnk/' + this.link
    },
    class_placeholder: function () {
      return (this.ativa_placeholder ? 'placeholder' : '');
    }
  },
  mounted() {
    this.img_load = false
    this.img_montada
  },
};
</script>

<style scoped>
/* div,
p {
  border: 1px solid red;
} */

p {
  display: block;
  text-align: center;
}

/* .bloco_link {
  height: 150px;
} */

.bloco_icon {
  font-size: 1.3rem;
}

/* .bloco_icon span {
  border-bottom: 1px solid var(--cor-base-texto);
} */

.titulo {
  text-align: left;
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--cor-base-texto);
}

.short_descr {
  font-size: .8rem;
}

.short_descr_cat {
  font-size: .8rem;
}

/* .imagem_thumb {
  max-height: 120px;
} */
.imagem_thumb {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 170px;
  transition: all .5s ease;
  position: relative;
  display: inline-block;
}

/* .imagem_thumb:hover {
  transition: all .5s ease;

  background-size: 150%;
} */

/* .imagem_thumb:hover:after {
  opacity: 1;
} */

.zoomimg {
  display: inline-block;
  /* width: 100%; */
  height: 180px;
  /* padding: 0px 5px 0px 5px; */
  background-size: cover;
  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center center;
  transition: all .5s ease;
  /* position: relative; */
}

/* .zoomimg:hover {
  cursor: pointer;
  background-size: 120% 120%;
} */
</style>